import {
  CheckmarkCircleRegular,
  ErrorCircleRegular,
  InfoRegular,
} from "@fluentui/react-icons";

import { cn } from "@/lib/utils";

const TONES = {
  success: {
    icon: CheckmarkCircleRegular,
    box: "border-[#86efac] bg-[#f0fdf4]",
    icons: "text-[#16a34a]",
  },
  danger: {
    icon: ErrorCircleRegular,
    box: "border-[#fca5a5] bg-[#fef2f2]",
    icons: "text-danger",
  },
  info: {
    icon: InfoRegular,
    box: "border-primary bg-light",
    icons: "text-[#7a8200]",
  },
};

/**
 * StatusBanner — Rückmeldung über dem Formular.
 *
 * Ersetzt die früheren Vollbild-Meldungen: die Eingaben bleiben sichtbar, und
 * im schmalen Task Pane geht kein Kontext verloren.
 */
export function StatusBanner({ tone = "info", title, children, className }) {
  const { icon: Icon, box, icons } = TONES[tone] || TONES.info;
  return (
    <div
      className={cn(
        "flex items-start gap-[0.8rem] rounded-card border px-[1.2rem] py-[1rem]",
        box,
        className,
      )}
    >
      <Icon className={cn("w-[1.8rem] h-[1.8rem] flex-shrink-0 mt-[0.1rem]", icons)} />
      <div className="min-w-0">
        {title && (
          <div className="text-[1.3rem] font-semibold text-foreground">{title}</div>
        )}
        {children && (
          <div className="text-[1.2rem] text-dim leading-snug mt-[0.2rem]">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
